export default __webpack_public_path__ + "static/media/lista_empresas.fa8611cd.svg";